module.exports = __webpack_public_path__ + "img/De-T200.d53a1cd6.gif";